// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import CategoryListResourceViewModel from '../../../../viewModel/resource/CategoryListResourceViewModel';
import CategoryParentReferenceResourceViewModel from '../../../../viewModel/resource/CategoryParentReferenceResourceViewModel';
import CategoryListResourceDTO from '../../dto/resource/CategoryListResourceDTO';

export default abstract class CategoryListResourceModel extends BaseModel<CategoryListResourceDTO> {
  /**
  */
  get id() { return this.dto.id; }

  set id(value) { this.dto.id = value; }

  /**
  */
  get title() { return this.dto.title; }

  set title(value) { this.dto.title = value; }

  /**
  */
  get categories() { return this.getArrayModels(() => this.dto.categories, CategoryListResourceViewModel)!; }

  set categories(value) { this.setArrayModels(() => this.dto.categories, value); }

  /**
  */
  get articles() { return this.dto.articles; }

  set articles(value) { this.dto.articles = value; }

  /**
  */
  get parent() { return this.getObjectModel(() => this.dto.parent, CategoryParentReferenceResourceViewModel)!; }

  set parent(value) { this.setObjectModel(() => this.dto.parent, value); }

  /**
  */
  get breadcrumb() { return this.getArrayModels(() => this.dto.breadcrumb, CategoryParentReferenceResourceViewModel)!; }

  set breadcrumb(value) { this.setArrayModels(() => this.dto.breadcrumb, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    this.dto.title = qs.title;
  }
}
